module.exports = __webpack_public_path__ + "img/cu06.c6a91d90.jpg";